const Pagination = ({
  lastRecord,
  paginationOffset,
  setPaginationOffset,
  rowsPerPage,
}) => {
  const isFirstPage = paginationOffset === 0
  const disableNext = lastRecord < (paginationOffset + 1) * 100

  const handlePrev = () => {
    if (!isFirstPage) {
      const newOffset = paginationOffset - 1
      setPaginationOffset(newOffset)
    }
  }

  const handleNext = () => {
    if (!disableNext) {
      const newOffset = paginationOffset + 1
      setPaginationOffset(newOffset)
    }
  }
  const currentPage = paginationOffset + 1
  // const rowsPerPage = lastRecord - 100 * (currentPage - 1)

  return (
    <div className="faxes-pagination">
      <label htmlFor="rowsPerPage" style={{ fontSize: "12px" }}>
        Rows per page:
      </label>
      <span style={{ marginRight: "10px" }}>{rowsPerPage}</span>
      <button
        className="faxes-pagination-button"
        onClick={handlePrev}
        disabled={isFirstPage}
      >
        Prev
      </button>
      <span>Page {currentPage}</span>
      <button
        className="faxes-pagination-button"
        onClick={handleNext}
        disabled={disableNext}
      >
        Next
      </button>
    </div>
  )
}

export default Pagination
